import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
function Curriculum() { 
  useEffect(() => {
    document.title = 'Curriculum -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li> Academics</li>
                <li>Curriculum</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Curriculum</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <p> As the school is affiliated with THE COUNCIL FOR THE INDIAN SCHOOL CERTIFICATE EXAMINATIONS, New Delhi, and provides education up to the ISC level, we follow the curriculum, examinations, and academic schemes stipulated by the Council.</p>
               <h5>Teaching Methodology:</h5>
               <p> At Mercy Memorial School, teaching is categorized as follows(As per NEP 2020)</p>
               <div className="teachingbox">
               <div className="teachingsec">
                       <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/Foundational.png" className="img-fluid" alt=" Mercy Memorial School, Kidwai Nagar, Kanpur"/></LazyLoad>
                       <p> Foundational Stage (PG – Class II) </p>
                  </div> 
                  <div className="teachingsec">
                       <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/Middle.png" className="img-fluid" alt=" Mercy Memorial School, Kidwai Nagar, Kanpur"/></LazyLoad>
                       <p> Preparatory Stage (III – Class V ) </p>
                  </div>
                  <div className="teachingsec">
                       <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/ICSE.png" className="img-fluid" alt=" Mercy Memorial School, Kidwai Nagar, Kanpur"/></LazyLoad>
                       <p> Middle School (Classes VI - VIII) </p>
                  </div>
                  <div className="teachingsec">
                       <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/ISC.png" className="img-fluid" alt=" Mercy Memorial School, Kidwai Nagar, Kanpur"/></LazyLoad>
                       <p> Secondary Stage (Classes IX - XII) </p>
                  </div>
               </div>
               <p> Mercy Memorial School enhances its instructional facilities in various ways with technological intervention there is improved teachers' effectiveness and proficiency, helping bridge the gap between abstract and complex concepts and real-life applications. It makes learning an enjoyable experience for students and fosters multi-sensory learning, which positively impacts academic performance.</p>

              <p> Continuous assessment aligned with learning outcomes is carried out through assignments, class tests, term tests, annual examinations etc. In addition to the core subjects, our teaching methodology also takes into account a student's academic, social, physical, emotional, and cultural needs while delivering an integrated curriculum. Subjects like Physical Education, Sports, Music, Drama etc. are an integral part of the curriculum.</p>
               
                    <h5>Course Offered</h5> 
                      <p><b>Subjects at the ICSE Level:</b></p>
                     <div className="primarycourse">
                       <ul className="mainlist">
                           <li>English</li>
                           <li>Hindi</li>
                           <li>History and Civics</li>
                           <li>Geography</li>
                           <li>Mathematics</li>
                           <li>Physics</li>
                           <li>Chemistry</li>
                           <li>Biology</li>
                           <li>Computer Science (Optional subject)</li> 
                           <li>Social and Useful Productive Work (S.U.P.W.)</li>     
                       </ul>
                    </div>
                      <p><b>Streams Offered at the ISC Level:</b></p>
                     <div className="primarycourse">
                        <p><b>Science Stream</b></p>
                       <ul className="mainlist">
                           <li>English</li>
                           <li>Physics</li>
                           <li>Chemistry</li>
                           <li>Biology</li>
                           <li>Mathematics/Hindi</li>
                           <li>Hindi</li>
                           <li>Physical Education</li>
                        </ul> 
                        <p><b>Commerce Stream</b></p>   
                        <ul className="mainlist">
                           <li>English</li>
                           <li>Commerce</li> 
                           <li>Economics</li>
                           <li>Accounts</li>
                           <li>Physical Education</li>  
                           <li>Mathematics </li>   
                           <li>Hindi</li>
                       </ul>
                    </div>
                       <h5>Evaluation</h5> 
                       <p> Every child is different and unique in their own way. At MMS, we offer a learning program where goals are shaped through levels of enrichment, improvement, and excellence, in alignment with each child’s potential.</p>
                        
                       <h6>Continuous assessment</h6>
                       <p>  The evaluation process at MMS is both objective and continuous, covering scholastic and non-scholastic achievements of students.</p>
                       <ul className="mainlist">
                       <li><b> Scholastic Category:</b> <br/>There is a unit test & term examination for all core subjects and languages.</li> 
                       <li> <b> Non-Scholastic Category: </b><br/>Students are graded in non-core subjects such as music, art and craft, dance and sports. <br/> Internal assessment is based on students' performance in projects, discussions, and assignments. </li>
                       </ul>

                       <h6>Student Support</h6>
                       <p> At MMS, we foster a warm, caring, and supportive environment. We provide personal, social, and emotional support to students through counselling and mentoring. Additionally, we offer remedial and enrichment programs for slow learners to ensure that every student has the opportunity to succeed.</p>
                         
                  </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Curriculum;
